import './css/Header.css';
import moment from 'moment';
import defaultShop from '../../../assets/default-shop.png';
import { environment } from 'src/environment/environment';
import { Util } from 'src/Util';

const Header = (props: { invoiceData: any; shopFields: any }) => {
  const { invoiceData, shopFields } = props;
  
  const timestamp = invoiceData?.createdAt;
  const dateTime = moment(timestamp);
  const secondField = shopFields?.secondField != "" && shopFields?.secondField != null
      ? shopFields?.secondField
      : 'Cashier';
  return (
    <div className="header-wrapper">
      <div className="header-container">
        <div className="main-title">
          <div className="logo">
            <img
              src={
                invoiceData?.shopId?.profileImageId == undefined
                  ? defaultShop
                  : environment.api_url +
                    '/api/public/file/' +
                    invoiceData?.shopId?.profileImageId._id +
                    '/' +
                    invoiceData?.shopId?.profileImageId.originalName
              }
              alt="Logo"
              className="logo-image"
            />
          </div>
          <div className="store-info">
            <h1 className="store-name">
              {invoiceData?.shopId.shopName}
            </h1>
            <p className="store-address">
              {invoiceData?.shopId.shopAddress}
            </p>
            <p className="store-phone">
              {Util.formatPhoneNumber(
                invoiceData?.shopId.phoneNumber
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="invoice-top-bar">
        <div className="invoice-bar" style={{backgroundImage: `linear-gradient(to right, ${shopFields?.firstThemeColor ?? `#976bdb`}, ${shopFields?.secondThemeColor ?? `#f63b95`})`}}></div>
        <div className="invoice-text">INVOICE</div>
        <div className="invoice-bar02" style={{backgroundColor: `${shopFields?.secondThemeColor ?? `#f63b95`}`}}></div>
      </div>
      {invoiceData?.invoiceNumber === 'PRE-INVOICE' && (
        <div className="quotation-title">QUOTATION</div>
      )}
      {invoiceData?.returnTag != '' && invoiceData?.returnTag != null && (
        <div>
          <div className="return-bill-title">RETURN BILL</div>
          <div className="return-tag-text">{invoiceData?.returnTag}</div>
        </div>
      )}
      {invoiceData?.invoiceItems.length === 0 && (
        <div>
          <div className="return-bill-title">FREE BILL</div>
          <div className="return-tag-text">No Charges Applied</div>
        </div>
      )}
      <div className="invoice-primary-details">
        <div className="invoice-primary-details-01">
          <p>
            <strong>{invoiceData?.customerName}</strong>
          </p>
          <p>
            <strong>
              {Util.formatPhoneNumber(
                invoiceData?.customerPhoneNumber
              )}
            </strong>
          </p>
          {invoiceData?.secondaryPhoneNumber != null &&
            invoiceData?.secondaryPhoneNumber != undefined && (
              <p>
                <strong>{invoiceData?.secondaryPhoneNumber}</strong>
              </p>
            )}
          {invoiceData?.customerAddress != null &&
            invoiceData?.customerAddress != undefined && (
              <p>
                <strong>{invoiceData?.customerAddress}</strong>
              </p>
            )}
          <p>
            <strong>
              {invoiceData?.invoiceNumber !== 'PRE-INVOICE'
                ? invoiceData?.invoiceNumber
                : invoiceData?.createdBy
                ? `${secondField}: ${invoiceData?.createdBy.name != null ? invoiceData?.createdBy.name : invoiceData?.creatorName}`
                : ''}
            </strong>
          </p>
          {invoiceData?.offlineSubAdminInvoiceNumber != null &&
            invoiceData?.offlineSubAdminInvoiceNumber != undefined && (
              <p>
                <strong>{invoiceData?.offlineSubAdminInvoiceNumber}</strong>
              </p>
            )}
          {invoiceData?.createdBy &&
            invoiceData?.invoiceNumber != 'PRE-INVOICE' && (
              <p>
                <strong>
                  {secondField}: {invoiceData?.createdBy.name != null ? invoiceData?.createdBy?.name : invoiceData?.creatorName}
                </strong>
              </p>
            )}
        </div>
        <div className="invoice-primary-details-02">
          <p>
            <strong>{dateTime.format('DD MMM YYYY')}</strong>
          </p>
          <p>
            <strong>{dateTime.format('h.mm a')}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Header;
